module.exports = __webpack_public_path__ + "img/acceso_restringido.d0c2613e.svg";